import { render } from "./RelatorioVinculosRequisicao.vue?vue&type=template&id=44f04c8a"
import script from "./RelatorioVinculosRequisicao.vue?vue&type=script&lang=js"
export * from "./RelatorioVinculosRequisicao.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__